module.exports = __webpack_public_path__ + "img/qr-3.fbc7ee7c.png";